import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import CatalogueSelectedTags from "~/modules/sort-and-filters/components/catalogue-selected-tags/catalogue-selected-tags";
import styles from "./product-filter-skin-1.module.css";
import { UiButton } from "~/components/ui-button";
import { useAppSearchParams } from "@commons-monorepo/index";

type Props = {
  showTags: boolean;
  showQuantityInTitle: boolean;
  onClick?: () => void;
  productsQuantity: number;
  isInServicesTab: boolean;
};

export const ProductFilterSkin1 = ({
  showTags,
  showQuantityInTitle,
  onClick,
  productsQuantity,
  isInServicesTab
}: Props) => {
  const { t } = useTranslation();
  const [searchParams] = useAppSearchParams();
  const selectedCategories = searchParams.get("categories")?.split("|") || [];
  const toppings = searchParams.get("toppings")?.split("|") || [];
  const filters = searchParams.get("filterBy")?.split(",") || [];

  const selectedFiltersQuantity = useMemo(() => {
    return selectedCategories?.length + toppings?.length + filters?.length;
  }, [selectedCategories, toppings, filters]);

  return (
    <div className={styles.productFilterSkin1Content}>
      <div className={styles.content}>
        {!showQuantityInTitle ?
        <div className={styles.title}>
            {isInServicesTab ?
          t("catalogueMain.all_services") :
          t("product_filter.title")}
          </div> :

        <div className={styles.quantityTitle}>{`${productsQuantity} ${t(
            "category.products"
          )}`}</div>}

        {onClick && !isInServicesTab &&
        <UiButton
          className={`${styles.filter}`}
          rightIcon={<span className={"icon-filters"} />}
          hasPersonalization
          isSpecial
          size='short'
          onClick={onClick}>

            {selectedFiltersQuantity > 0 &&
          <span className={styles.quantity}>{selectedFiltersQuantity}</span>}

          </UiButton>}

      </div>
      {showTags && <CatalogueSelectedTags />}
      {!showQuantityInTitle && selectedFiltersQuantity > 0 &&
      <div className={styles.quantityTitle}>{`${t(
          "category.showing"
        )} ${productsQuantity} ${t("category.products")}`}</div>}

    </div>);

};